import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import faq from './Faq.json'
function Faq() {

    const [faqlist, setfaqlist] = useState(faq)

    return (

        <Box className='h-100 w-100 p-3'>
            {faq.map((item: any, index) => (
                <Box className='border p-2  pb-0 mb-2 border-10'>
                    <Typography
                        className="fw-bolder"
                        dangerouslySetInnerHTML={{ __html: item?.quetion }}
                    />
                    {item?.answers?.map((ans: any, idx: number) => (
                        <div key={idx} style={{ marginTop: "10px", marginBottom:"0px"}}>
                            {/* Answer label */}
                            <Typography
                                variant="body1"
                                dangerouslySetInnerHTML={{ __html: ans.label }}
                            />
                            {/* Help images */}
                            {ans?.helpImage.length > 0 &&  ans.helpImage?.map((img: string, imgIdx: number) => (
                                <div key={imgIdx} style={{ marginTop: "5px" }}>
                                    <img
                                        src={img}
                                        alt=''
                                        style={{ maxWidth: "300px", borderRadius: "8px" }}
                                    />
                                </div>
                            ))}
                           {idx!= item?.answers.length - 1 && <hr />}
                        </div>
                    ))}
                </Box>
            ))}

        </Box>
    )
}

export default Faq
